import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/fornecedor';

export default {
  cadastrar: async (fornecedor) => {
    return financeiroApi.post(`${PATH}`, fornecedor);
  },
  buscarPorId: async (key) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(key)}`);
  },
  buscar: async (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),
  atualizar: async (id, fornecedor) => {
    return financeiroApi.put(`${PATH}/${id}`, fornecedor);
  },
  removerFornecedores: async (ids) => {
    return financeiroApi.delete(`${PATH}/${ids}`);
  },

  removerFornecedoresTodosFiltro: async (params) => {
    return financeiroApi.delete(`${PATH}/todosFiltro`, { params });
  },

  obterModelo: () => {
    return financeiroApi.get(`${PATH}/modelo`);
  },

  importarPlanilha: async (file, idNotificacao) => {
    try {
      return financeiroApi.post(`${PATH}/importar?idNotificacao=${idNotificacao}`, file, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    } catch (error) {
      throw error;
    }
  },
};
